import { createRoot } from "react-dom/client";
import React from "react";
import { StageCarousel } from "~assets/frontend/modules/mod-stage_carousel/mod-stage_carousel";
export const StageCarouselLoader = (carousels) => {
    carousels.forEach((element) => {
        const json = element.getAttribute("data-json");
        if (json) {
            const config = JSON.parse(json);
            const root = createRoot(element);
            root.render(React.createElement(StageCarousel, Object.assign({}, config)));
        }
    });
};
